import React from 'react';
import PropTypes from 'prop-types';
import {contentUtils, HTMLContent} from "mindsets-js-sdk";


function DnDDraggableItem({item}) {
    function getDraggableStyle(default_style) {
        return {
            transform: undefined,
            cursor: 'default',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0",
            minHeight: "50px",
            minWidth: "50px",
            borderRadius: "4px",
            position: "relative",
            zIndex: 1,
            ..._.get(item, 'draggable_style'),
            ...default_style
        }
    }

    function getContent() {
        const contentImage = _.get(item, 'content.image');
        const contentImageAlt = _.get(item, 'content.image_alt', undefined);
        const contentHtml = _.get(item, 'content.html');
        if (contentImage) {
            return (
                <img src={contentImage} alt={contentImageAlt}/>
            )
        } else if (contentHtml) {
            return (
                <HTMLContent html_str={contentUtils.processStringContent(contentHtml)}/>
            );
        } else {
            return null;
        }
    }

    return (
        <div
            className="dnd-option"
            style={getDraggableStyle()}
        >
            {getContent()}
        </div>
    );
}

DnDDraggableItem.propTypes = {
    item: PropTypes.shape({
        content: PropTypes.shape({
            image: PropTypes.string,
            image_alt: PropTypes.string,
            html: PropTypes.string
        }).isRequired,
        draggable_style: PropTypes.object
    }).isRequired
}

export default DnDDraggableItem
